// TODO: Replace the hardcoded with real values + math.

import styled, { keyframes } from 'styled-components'
import useIsMobile from 'hooks/util/useIsMobile'
import { PrimaryButton } from 'components/core/Buttons'
import DepositGoo from 'components/core/icons/factory/DepositGoo'
import WithdrawGoo from 'components/core/icons/factory/WithdrawGoo'
import GooEquation from 'components/factory/GooEquation'
import { device } from 'components/draw/constants'
import { animated, SpringValue } from '@react-spring/web'
import { Spacer } from 'components/core/Spacer'

interface GooContainerProps {
  showNoGooView: boolean
}
const GooContainer = styled.div<GooContainerProps>`
  position: relative;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  background-color: ${(props) => (props.showNoGooView ? 'white' : '#AAECCB')};

  width: calc(100% - 64px);
  max-width: 1312px;

  aspect-ratio: 2250 / 950;

  border: 10px solid #000000;

  overflow: hidden;

  border-radius: 64px;

  padding: 0 116px;
  box-shadow: 0px -3px 8px rgba(255, 255, 255, 0.2), 0px 24px 40px rgba(0, 0, 0, 0.08),
    0px 12px 20px rgba(0, 0, 0, 0.06), 0px 4px 8px rgba(0, 0, 0, 0.04);

  @media (max-width: 1280px) {
    padding: 32px 80px;
  }

  @media (max-width: 1140px) {
    padding: 32px;
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  height: auto;
  padding: 32px 16px; 
  gap: 24px;

  border-width: 5px;
  border-radius: 32px;

  width: calc(100% - 40px);
  
  aspect-ratio: auto;
  `};
`

const GooFactoryBG = styled.img`
  position: absolute;
  object-fit: cover;
  z-index: 1;
  left: 0px;
  right: 0;
  transform: scale(1.03);

  height: calc(100% + 10px);
  bottom: 0;
  top: -10px;
`

// Goo Left
const GooLeftContainer = styled.div`
  z-index: 7;
  color: black;
  font-family: 'Matter';
  font-weight: 700;
  display: flex;
  flex-direction: column;
`

const GooLeftTitle = styled.div`
  font-size: 20px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-top: 32px;
    margin-left: 16px;
  `};
`

const GooLeftAmount = styled.div<{ shorten: boolean }>`
  font-size: ${(props) => (props.shorten ? 76 : 96)}px;
  font-variant-numeric: tabular-nums;

  @media ${device.laptopMax} {
    font-size: ${(props) => (props.shorten ? 42 : 60)}px;
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
  margin-left: 16px;
  `};
`

const AnimatedGooLeftAmount = animated(GooLeftAmount)

const GooLeftButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-top: -12px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
  margin-left: 16px;
  `};
`

export interface GooFactoryProps {
  emissionsMultiple: number | undefined
  gooVirtualBalanceOnPageLoad: number | undefined
  gooSpring: {
    amount: SpringValue<number>
  }
  showNoGooView: boolean
  gobblerIdsOwned: Array<number> | undefined
  handleWithdrawGoo: () => void
  handleOpenDepositGooModal: () => void
}

const GooTopContainer = (props: GooFactoryProps) => {
  const showNoGooView = props.showNoGooView

  const fixedFormattingAmount = 6
  const fixedFormattingSmallAmount = 8

  const isMobile = useIsMobile(720)
  const buttonStyle = isMobile
    ? {
        fontSize: 18,
        width: 130,
        height: 42,
      }
    : { fontSize: 20, width: 180, height: 56 }

  const iconStyle = isMobile ? { marginRight: 4, paddingTop: 3 } : { marginRight: 8, paddingTop: 3 }

  return (
    <GooContainer showNoGooView={showNoGooView}>
      {showNoGooView && <GooFactoryBG src="/images/factory/empty-goo-factory.gif" />}
      {/* <FactoryBookmarkContainer>
        <FactoryBookmark />
      </FactoryBookmarkContainer> */}
      {!showNoGooView && <GooFactoryBG src="/images/factory/full-goo-factory.gif" />}
      {/* <GooLeft {...props} /> */}
      <GooLeftContainer>
        <GooLeftTitle>Your Goo in factory</GooLeftTitle>
        <AnimatedGooLeftAmount shorten={isMobile}>
          {props.gooSpring.amount.to((c) =>
            c > 1 ? c.toFixed(fixedFormattingAmount) : c.toFixed(fixedFormattingSmallAmount),
          )}
        </AnimatedGooLeftAmount>
        <Spacer size={20} />

        {!showNoGooView && (
          <GooLeftButtons>
            <PrimaryButton onPress={props.handleOpenDepositGooModal} style={buttonStyle}>
              <DepositGoo style={iconStyle} />
              Deposit
            </PrimaryButton>
            <PrimaryButton onPress={props.handleWithdrawGoo} style={buttonStyle}>
              <WithdrawGoo style={iconStyle} />
              Claim
            </PrimaryButton>
          </GooLeftButtons>
        )}
        <Spacer size={20} />
        {!showNoGooView && (
          <GooEquation
            multiplier={props.emissionsMultiple ?? 0}
            gooStaked={props.gooVirtualBalanceOnPageLoad ?? 0}
          />
        )}
      </GooLeftContainer>
      ){/* {!showNoGooView && <div style={{ flexGrow: 1, minWidth: 20 }} />} */}
    </GooContainer>
  )
}

export default GooTopContainer
